import React from "react";
import { UserCheck } from "lucide-react";
import { useData } from "@/context/DataContext";
import { mismoNombre } from "@/lib/inicio";

export const SIN_ASIGNAR = "Sin asignar";
export const nombrePersona = (familyMembers, id) => (familyMembers || []).find((f) => f.id === id)?.name || SIN_ASIGNAR;

// Persona de la cuenta cuyo nombre coincide con algún titular leído en la reserva (solo sugerencia).
export const sugerirPersona = (familyMembers, titulares) => {
  const nombres = Array.isArray(titulares) ? titulares.map(String) : [];
  return (familyMembers || []).find((f) => nombres.some((n) => mismoNombre(n, f.name) || mismoNombre(n.split(/\s+/)[0], f.name)));
};

const chip = (on) => `min-h-[44px] px-4 rounded-xl border-2 font-semibold text-base ${on ? "bg-[#3A6B56] border-[#3A6B56] text-white" : "bg-white border-[#E5DFD5] text-[#1C2421]"}`;

// «¿De quién es este plan?» + otros participantes opcionales.
export const PersonaPlan = ({ principal, participantes, onChange, sugerida }) => {
  const { familyMembers = [] } = useData();
  const miembros = [...familyMembers].sort((a, b) => (b.es_titular ? 1 : 0) - (a.es_titular ? 1 : 0));
  const set = (p, parts) => onChange(p || null, (parts || []).filter((x) => x !== p));
  const otros = miembros.filter((m) => m.id !== principal);
  return (
    <div className="space-y-3" data-testid="ocio-persona">
      <div>
        <label htmlFor="ocio-persona-select" className="block text-base font-semibold text-[#1C2421]">¿De quién es este plan?</label>
        <select id="ocio-persona-select" data-testid="ocio-persona-select" value={principal || ""} onChange={(e) => set(e.target.value, participantes)}
          className="w-full mt-1 min-h-[52px] px-4 rounded-xl border border-[#E5DFD5] bg-white text-base">
          {miembros.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          <option value="">{SIN_ASIGNAR}</option>
        </select>
      </div>
      {sugerida && sugerida.id !== principal && (
        <div className="bg-[#E8F0EC] rounded-xl p-3" data-testid="ocio-persona-sugerencia">
          <p className="text-base text-[#1C2421]">La reserva parece estar a nombre de <b>{sugerida.name}</b>.</p>
          <button type="button" data-testid="ocio-persona-sugerencia-aceptar" onClick={() => set(sugerida.id, participantes)}
            className="mt-2 inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-xl bg-[#3A6B56] text-white font-semibold"><UserCheck size={18} /> Sí, es de {sugerida.name}</button>
        </div>
      )}
      {otros.length > 0 && (
        <div>
          <p className="text-base font-semibold text-[#1C2421]">Otros participantes <span className="font-normal text-[#6E7A74]">(opcional)</span></p>
          <div className="flex flex-wrap gap-2 mt-1">
            {otros.map((m) => {
              const on = (participantes || []).includes(m.id);
              return <button type="button" key={m.id} data-testid={`ocio-participante-${m.id}`} aria-pressed={on} className={chip(on)}
                onClick={() => set(principal, on ? participantes.filter((x) => x !== m.id) : [...(participantes || []), m.id])}>{m.name}</button>;
            })}
          </div>
        </div>
      )}
    </div>
  );
};
